// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e743ffe0","703":"9b78c38e","833":"ea35f9dc"}[chunkId] + ".chunk.js";
};